import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { PRD5040_R01ResultDto } from "./Dto_PRD5040_R01";
import { PRD5040_R01Filter } from "./Store_PRD5040_R01";

// PRD5040_R01 API 공통 base URL
const baseUrl = `${config.apiUrl}/PRD5040_R01`;

// 필터 객체를 axios 쿼리 파라미터 객체로 변환하는 함수
// - 빈 문자열은 undefined로 바꿔 쿼리스트링에서 제외되도록 처리
const getParams = (filter: Partial<PRD5040_R01Filter>) => ({
	compCd: filter.compCd || undefined,           // 사업장 (없으면 파라미터 제외 = 전체)
	year: filter.year,                            // 조회 연도
	workplaceCd: filter.workplaceCd || undefined, // 공정 (없으면 파라미터 제외 = 전체)
	itemGroup: filter.itemGroup || undefined,     // 품목그룹 (없으면 파라미터 제외 = 전체)
	itemCd: filter.itemCd || undefined,           // 품목코드 (없으면 파라미터 제외 = 전체)
});

// 월별 양품율 목록 조회 API 호출 함수
export const getPRD5040_R01List = async (
	option: string,                       // "" | "search" | "refetch"
	filter: Partial<PRD5040_R01Filter>    // 검색 조건
) => {
	const url = `${baseUrl}/${option}`; // 옵션에 따른 최종 요청 URL
	return await getData<ResponseDto<PRD5040_R01ResultDto[]>>(url, { params: getParams(filter) });
};
